import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './prompts.loaders';
import { PromptsFilters } from './prompts.types';
import { converters } from './prompts.converters';

export const promptsKeys = queryKeyFactory('prompts');

export const usePrompts = (filters: Partial<PromptsFilters> = {}) => {
  return useQuery({
    queryKey: promptsKeys.list(filters),
    queryFn: () => loaders.getPrompts({ filters }),
    select: converters.getPrompts,
  });
};
